import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDInput from "components/MDInput";
import {
  Alert,
  AppBar,
  Card,
  Checkbox,
  FormControlLabel,
  Snackbar,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  FormControl
} from "@mui/material";
import MDButton from "components/MDButton";
import {PATCH} from "APIclient";
import {useLocation} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import {column} from "stylis";
//   React context
import {useMaterialUIController} from "context";
import {GET} from "APIclient";
import properties from "constants/ApplicationConstants";

function HideLocation(details, noGutter) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();
  const [formData, setFormData] = React.useState({});
  const [employeeList, setEmployeeList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");

  const handleCloseSnackbar = () => setSnackbar(null);

  useEffect(() => {
    const url = `admin/employeeDetails`;
    const fetchEmployees = async () => {
      try {
        const response = await GET(url);
        if (response.status === 200 && Array.isArray(response.data.data)) {
          // setSnackMessage(response.data.message);
          // setSnackColor("success");
          // setSnackOpen(true);
          setEmployeeList(response.data.data);
        } else {
          setEmployeeList([]);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
        setEmployeeList([]);
        if (error.response) {
          setSnackMessage(error.response.data.message);
          setSnackColor("error");
          setSnackOpen(true);
        } else {
          setSnackMessage("Error fetching employees data");
          setSnackColor("error");
          setSnackOpen(true);
        }
      }
    };
    fetchEmployees();
  }, []);

  const handleChange = event => {
    const {name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleClose = event => {
    setOpen(false);
  };

  const handleSubmit = async val => {
    // Prepare the data to be sent to the server
    // const formData = {
    //     empId: usersState
    // };

    const url = `admin/hide-location/${usersState}/${val}`;

    try {
      const response = await PATCH(url, formData);
      if (response?.data?.statusCode === 200) {
        // Successfully updated
        setSnakColor(val == 1 ? "success" : "info");
        setSnakMessage(response?.data?.message);
        setOpen(true);
        // Optionally navigate to another page after successful update
        // navigate('/some/other/page');
      } else {
        setSnakColor("error");
        setSnakMessage(response?.data?.statusCode + " " + response?.data?.message);
        setOpen(true);
      }
    } catch (error) {
      let response = error.response;
      // console.error('Error updating permissions:', error);
      setSnakColor("error");
      setSnakMessage(response?.data?.statusCode + " " + response?.data?.message);
      setOpen(true);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox container>
        <AppBar position="static">
          <Card>
            <MDBox
              pt={2}
              mb={0}
              pb={4}
              px={4}
              sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
            >
              <Typography variant="h6" fontFamily={properties.fontFamily}>
                {" "}
                Hide Location
              </Typography>
              <MDBox pt={2} mb={0} pb={4} px={4}>
                {/* <InputLabel sx={{ fontWeight: 'bold', paddingBottom: '20px' }}>Roster Details</InputLabel> */}

                <FormControl variant="standard" sx={{m: 1, width: "30ch"}}>
                  <InputLabel id="MasterTeam">Employee Name *</InputLabel>
                  <Select
                    value={formData ? formData.empId : ""}
                    name="empId"
                    label="Select "
                    onChange={e => handleChange(e)}
                    IconComponent={ExpandMoreIcon}
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {employeeList.length > 0 ? (
                      employeeList.map(employee => (
                        <MenuItem key={employee.empId} value={employee.empId}>
                          {employee.firstName} {employee.lastName} [{employee.empId}]
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No employees available</MenuItem>
                    )}
                    {/* <MenuItem value={usersState}>[{usersState}] Dhanashri Jagadale</MenuItem> */}
                    {/* <MenuItem value="2">[18201] Pallavi Sonawane</MenuItem> */}
                  </Select>
                </FormControl>
              </MDBox>

              <MDBox mt={3} mb={2} sx={{display: "grid", gridAutoColumns: "1fr", gap: 1}}>
                <MDBox sx={{gridRow: "1", gridColumn: "3/ 5"}}>
                  <MDButton
                    variant="gradient"
                    color="info"
                    sx={{
                      marginRight: "10px",
                      background: properties.colors.bgcolorbluethem,
                      fontFamily: properties.fontFamily,
                      width: "20ch"
                    }}
                    onClick={() => handleSubmit(1)}
                  >
                    Save
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    sx={{width: "20ch", fontFamily: properties.fontFamily}}
                    onClick={() => handleSubmit(0)}
                  >
                    Remove
                  </MDButton>
                </MDBox>
              </MDBox>

              <Snackbar
                open={open}
                anchorOrigin={{vertical: "top", horizontal: "right"}}
                autoHideDuration={3000}
                onClose={handleClose}
              >
                <Alert
                  onClose={handleClose}
                  severity={snakColor === "success" ? "success" : "error"}
                  variant="filled"
                  sx={{width: "100%"}}
                >
                  {snakMessage}
                </Alert>
              </Snackbar>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default HideLocation;
